import React from "react";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import Button from "../../atoms/Button";
import InputField from "../../atoms/InputField";
import { UPDATE_LAWYER } from "../../../api/apiAdmin";

const EditAbogado = ({ abogado, onClose, refetch}) => {
    const validate = (values) => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!values.name) { errors.name = "El nombre es requerido"; }
        if (!values.email) { errors.email = "El email es requerido"; }
            else if (!emailRegex.test(values.email)) { errors.email = "El email no es válido"; }
        return errors;
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await UPDATE_LAWYER(abogado.id, values);
            toast.success("Registro exitoso");
            refetch();
            onClose();
        } catch(error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = {
        name: abogado.name || "",
        email: abogado.user.email || "",
        password: "",
        cellphone: abogado.cellphone ||"",
    };

    return(
        <div>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validate} >
                {({ isSubmitting }) => (
                    <Form className="w-full flex flex-col items-center justify-center text-center space-y-4">
                        <InputField name="name" label="Nombre completo" placeholder="Nombre completo" />
                        <InputField name="email" label="Correo electrónico" placeholder="Correo electrónico" />
                        <InputField name="cellphone" label="Numero de telefono" placeholder="Numero de telefono" />
                        <InputField name="password" label="Contraseña" type="password" placeholder="Contraseña" />
                        <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Registrar"} type="submit" disabled={isSubmitting} bgColor="blue" />
                    </Form>
                )}
            </Formik>
        </div>
    )
};

export default EditAbogado;